import axios from 'axios';
import baseConfig from '@config/base.config';
import cookieUtils from '@utils/cookie.utils';
import uuidUtils from '@utils/uuid.utils';
import { logout } from '@master/hooks/service/useLogin';
import PtMessage from '@ui/message';
import i18n from '@assets/i18n/index';
import { debounce } from 'lodash-es';

import { useAccountInfo } from '@models/account/useAccountInfo';
import { useProfileInfo } from '@models/profile/useCurrentProfile';

const { account } = useAccountInfo();
const { profileInfo } = useProfileInfo();
const ipNoAccess = 'PTX_ACCESS_IP_NOT_IN_WHITELIST';

let source = axios.CancelToken.source();

axios.interceptors.request.use(
    function (config: any) {
        if (config.getManifest) return config;
        if (!config.cancelToken) config.cancelToken = source.token;

        const { ACCOUNT_TOKEN, LAST_PROFILE_ID } = baseConfig;
        const token = localStorage.getItem(ACCOUNT_TOKEN) || cookieUtils.getItem(ACCOUNT_TOKEN);
        const uid = account.value?.id;
        const sid = profileInfo.value?.sid || cookieUtils.getItem(LAST_PROFILE_ID);
        if (token && !config.headers.authorization)
            config.headers['authorization'] = `Bearer ${token}`;
        if (uid) config.headers['uid'] = uid;
        if (sid) config.headers['sid'] = sid;
        config.headers['traceId'] = uuidUtils.uuid();
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error?.message === 'Network Error') {
            PtMessage.error(i18n.global.t('login.network_error'));
        } else {
            handleResponseError(error?.response?.status, error?.response?.data);
        }
        return Promise.reject(error);
    }
);

export const setMessageTip = debounce(message => {
    PtMessage.info(message);
    setTimeout(() => {
        logout('ip_no_access', 'http_interceptor');
    }, 1500);
}, 500);

export const handleResponseError = (status: number, result: any) => {
    if (result?.code === 'PTX_FORBIDDEN') {
        logout('error_token', 'http_interceptor');
        source.cancel();
        source = axios.CancelToken.source();
    } else if (result?.code === ipNoAccess) {
        setMessageTip(i18n.global.t('login.ptengine_ip_noaccess'));
        return;
    }
    if (status === 403) {
        logout('error_token', 'http_interceptor');
    }
};
